import React, { useState, useEffect } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/Capital.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import moment from "moment";

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};
const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};
const todayDate = new Date().toISOString().slice(0, 16); // Format as 'YYYY-MM-DDTHH:MM'

export default function Capital() {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [CapitalList, SetCapitalList] = useState([]);
  const [selectedCapital, setSelectedCapital] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [isDateInput, setIsDateInput] = useState(false);

  const filteredCapitalList = searchQuery
    ? CapitalList.filter((item) =>
        item.Asset_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : CapitalList;

  const InitState = {
    assetDate: null,
    assetName: null,
    amount: null,
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const fetchCapitalList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/asset/FetchCapitalList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetCapitalList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchCapitalList();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Capital) => {
    const InitStateEdit = {
      Asset_Id: Capital.Asset_Id,
      assetDate:
        Capital.Asset_Date == null
          ? null
          : convert(Capital.Asset_Date.toString()),
      assetName: Capital.Asset_Name,
      amount: Capital.Amount,
      user: username,
    };
    setSelectedCapital(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if(confirmClose){
    setModalIsOpen(false);
    setFormData(InitState);
    setSelectedCapital(null);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value);
    const pattern = /[^a-zA-Z0-9 ]/g;
    if (name === "assetName") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "assetDate") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setFormData({
          ...formData,
          [name]: convert(date),
        });
      }
    } else if (name === "amount") {
      setFormData({
        ...formData,
        [name]: value.replace(/[^0-9]/g, "").slice(0, 9),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z0-9 ]/g;
    if (name === "assetName") {
      let result = pattern.test(value);
      if (result) {
        setSelectedCapital({
          ...selectedCapital,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setSelectedCapital({
          ...selectedCapital,
          [name]: value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase(),
        });
      }
    } else if (name === "assetDate") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setSelectedCapital({
          ...selectedCapital,
          [name]: convert(date),
        });
        // Switch back to text to display the formatted date
      }
    } else if (name === "amount") {
      setSelectedCapital({
        ...selectedCapital,
        [name]: value.replace(/[^0-9]/g, "").slice(0, 9),
      });
    } else {
      setSelectedCapital({
        ...selectedCapital,
        [name]: value,
      });
    }
  };

  const handleFocus = () => {
    setIsDateInput(true);
  };
  const handleFocus1 = () => {
    setIsDateInput(false);
  };

  const UpdateForm = async (e) => {
    e.preventDefault()
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/asset/UpdateCapital/${selectedCapital.Asset_Id}`,
          selectedCapital,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedCapital([]);
          fetchCapitalList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    setSelectedCapital([]);
    setFormData(InitState);
    closeModal();
  };
  const handleDelete = async (Capital) => {
    try {
      const confirm= window.confirm("Are you sure you want to delete this?")
      if(!confirm) return
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/asset/DeleteCapital/${Capital.Asset_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            fetchCapitalList();
          } else if (res.status === 500) {
            FailedMSG(res.data.message);
            window.location.reload();
          }
          fetchCapitalList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/asset/AddCapital`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          fetchCapitalList();
          SuccessMSG(res.data.message);
          setFormData(InitState);
          fetchCapitalList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    setFormData(InitState);
    closeModal();
  };

  return (
    <>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>
      <div className="Capital">
        <Menu username={username} rights={rights} i={"Asset"}></Menu>
        <div className="CapitalPage">
          <p className="CapitalHeadLabel">Capital</p>
          <div className="CapitalHeaders">
            <div className="CapitalRegSearch">
              <input
                className="CapitalRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Name"
              ></input>
              <button className="CapitalSearchBtn">
                <FontAwesomeIcon
                  className="CapitalRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewCapitalBtn"
              title="Add New"
              onClick={openModal}
            >
              Add New{" "}
              <FontAwesomeIcon
                className="CapitalAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            shouldCloseOnOverlayClick={false}
            contentLabel="Capital Form"
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "50px",
                left: "25%",
                right: "25%",
                bottom: "50px",
                height: "50%",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="CapitalFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="CapitalFormHeadLabel">
              {selectedCapital?.Asset_Id ? "Edit Capital" : "Add Capital"}
            </p>
            <form
              className="CapitalForm"
              onSubmit={selectedCapital?.Asset_Id ? UpdateForm : handleSubmit}
            >
              <div className="CapitalFormFlex">
                <div className="Capitalform1">
                  <div className="CapitalformFeilds">
                    <label className="CapitalFormLabels">
                      Date <span>*</span>
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      required
                      type={isDateInput ? "date" : "text"}
                      onFocus={handleFocus}
                      onBlur={handleFocus1}
                      readOnly={!isDateInput}
                      max={todayDate}
                      value={
                        selectedCapital?.Asset_Id
                          ? selectedCapital.assetDate
                            ? FormatDate(selectedCapital.assetDate)
                            : selectedCapital.assetDate
                          : formData.assetDate
                          ? FormatDate(formData.assetDate)
                          : formData.assetDate
                      }
                      onChange={
                        selectedCapital?.Asset_Id ? handleUpdate : handleChange
                      }
                      className="CapitalFormInputs"
                      name="assetDate"
                    ></input>
                  </div>
                </div>
                <div className="Capitalform1">
                  <div className="CapitalformFeilds">
                    <label className="CapitalFormLabels">
                      Name <span>*</span>{" "}
                    </label>
                    <input
                      placeholder="Name"
                      value={
                        selectedCapital
                          ? selectedCapital.assetName
                          : formData.assetName
                      }
                      onChange={
                        selectedCapital?.Asset_Id ? handleUpdate : handleChange
                      }
                      className="CapitalFormInputs"
                      required
                      type="text"
                      name="assetName"
                    ></input>
                  </div>
                  <div className="CapitalformFeilds">
                    <label className="CapitalFormLabels">
                      Amount <span>*</span>
                    </label>
                    <input
                      placeholder="Amount"
                      required
                      value={selectedCapital?.amount || formData.amount}
                      onChange={
                        selectedCapital?.Asset_Id ? handleUpdate : handleChange
                      }
                      className="CapitalFormInputs"
                      type="text"
                      name="amount"
                    ></input>
                  </div>
                </div>
              </div>
              <div className="CapitalFormFooter">
                <div className="CapitalFormFooterBtns">
                  <button
                    className="CapitalFormSubmitBtn"
                    title="Confirm"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <div className="CapitalLists">
            {/* {console.log(filteredCapitalList)} */}
            {filteredCapitalList.length < 1 ? (
              <p className="mx-auto" style={{textAlign:"center", width:"100%"}}>There are no Capitals</p>
            ) : (
              filteredCapitalList.map((items, index) =>
                items.Amount ? (
                  <div key={index} className="CapitalIndex">
                    <div className="CapitalGrp0">
                      <div className="CapitalIconGrp">
                        <FontAwesomeIcon
                          className="CapitalUsesCircle"
                          icon={faUserCircle}
                        />
                      </div>
                      <div className="CapitalGrp" style={{ width: "40%" }}>
                        <p className="CapitalGrpLables">Id</p>
                        <p className="CapitalGrpValues">{items.Asset_Id}</p>
                      </div>
                      <div className="CapitalGrp" style={{ width: "80%" }}>
                        <p className="CapitalGrpLables">Name</p>
                        <p className="CapitalGrpValues">{items.Asset_Name}</p>
                      </div>
                    </div>
                    <div className="CapitalGrp">
                      <p className="CapitalGrpLables">Date</p>
                      <p className="CapitalGrpValues">
                        {FormatDate(convert(items.Asset_Date))}
                      </p>
                    </div>
                    <div className="CapitalGrp">
                      <p className="CapitalGrpLables">Amount</p>
                      <p className="CapitalGrpValues">{items.Amount}</p>
                    </div>
                    <div className="CapitalGrpBtn">
                      <FontAwesomeIcon
                        className="CapitalEditIcon"
                        title="Edit"
                        icon={faEdit}
                        onClick={() => handleEdit(items)}
                      />
                      <FontAwesomeIcon
                        className="CapitalDeleteIcon"
                        title="Delete"
                        onClick={() => handleDelete(items)}
                        icon={faTrash}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )
              )
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

/*

                {CapitalList.length <1 ? <p>There is No Capitals</p>:
                CapitalList.map((items,index)=>{
                    return <><div className='CapitalIndex'>
                    <div className='CapitalGrp0'>
                      <div className='CapitalIconGrp'><FontAwesomeIcon className='CapitalUsesCircle' icon={faUserCircle}></FontAwesomeIcon></div>
                      <div  className='CapitalGrp' style={{width:"40%"}}>
                      <p className='CapitalGrpLables'>Id</p>
                      <p className='CapitalGrpValues'>{items.Capital_Id}</p>
                      </div>
                      <div  className='CapitalGrp'style={{width:"80%"}} >
                      <p className='CapitalGrpLables'>Capital Name</p>
                      <p className='CapitalGrpValues'>{items.Capital_Name}</p>
                      </div>
                    </div>
                    <div className='CapitalGrp'>
                      <p className='CapitalGrpLables'>Capital Contact</p>
                      <p className='CapitalGrpValues'>{items.Contact1}</p>
                    </div>
                    <div className='CapitalGrp'>
                      <p className='CapitalGrpLables'>Aadhar Number</p>
                      <p className='CapitalGrpValues'>{(items.Aadhar_Number)}</p>
                    </div>
                    <div className='CapitalGrpBtn'>
                      <FontAwesomeIcon className='CapitalEditIcon' title='Edit' icon={faEdit} onClick={()=>handleEdit(items)}></FontAwesomeIcon>
                      <FontAwesomeIcon className='CapitalDeleteIcon' title='Delete' onClick={()=>handleDelete(items)} icon={faTrash}></FontAwesomeIcon>
                    </div>
                  </div>
                    </>
                })} 
                    */
